import {
  PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR,
  PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR
} from '../../profile/constants/tag'
import { defineMessages } from 'react-intl'

export const PLAN_TAG = {
  ALL: 'all',
  WOMEN: 'women',
  MEN: 'men',
  CALISTHENICS: 'calisthenics',
  SUMMER: 'summer',
  FAT_LOSS: 'fat loss',
  BEGINNER: 'beginner',
  INTERMEDIATE: 'intermediate',
  ADVANCED: 'advanced',
  HIIT: 'hiit',
  POWERHYBRID: 'powerhybrid',
  HOME: 'home',
  DUMBBELL: 'dumbbell',
  FULL_BODY: 'full body',
  KETTLEBELL: 'kettlebell',
  RESISTANCE_BAND: 'resistance band',
  RUNNING: 'running',
  SENIOR: 'senior'
}
export const PLAN_TAGS = Object.values(PLAN_TAG)

const planTagMessage = defineMessages({
  all: {
    id: 'planTagMessage.all',
    defaultMessage: 'All'
  },
  women: {
    id: 'planTagMessage.women',
    defaultMessage: 'Women'
  },
  men: {
    id: 'planTagMessage.men',
    defaultMessage: 'Men'
  },
  summer: {
    id: 'planTagMessage.summer',
    defaultMessage: 'Summer'
  },
  calisthenics: {
    id: 'planTagMessage.calisthenics',
    defaultMessage: 'Calisthenics'
  },
  fatLoss: {
    id: 'planTagMessage.fatLoss',
    defaultMessage: 'Fat loss'
  },
  powerhybrid: {
    id: 'planTagMessage.powerhybrid',
    defaultMessage: 'Powerhybrid'
  },
  beginner: {
    id: 'planTagMessage.beginner',
    defaultMessage: 'Beginner'
  },
  intermediate: {
    id: 'planTagMessage.intermediate',
    defaultMessage: 'Intermediate'
  },
  advanced: {
    id: 'planTagMessage.advanced',
    defaultMessage: 'Advanced'
  },
  hiit: {
    id: 'planTagMessage.hiit',
    defaultMessage: 'HIIT'
  },
  home: {
    id: 'planTagMessage.home',
    defaultMessage: 'Home'
  },
  dumbbell: {
    id: 'planTagMessage.dumbbell',
    defaultMessage: 'Dumbbell'
  },
  fullBody: {
    id: 'planTagMessage.fullBody',
    defaultMessage: 'Full body'
  },
  kettlebell: {
    id: 'planTagMessage.kettlebell',
    defaultMessage: 'Kettlebell'
  },
  resistanceBand: {
    id: 'planTagMessage.resistanceBand',
    defaultMessage: 'Resistance band'
  },
  running: {
    id: 'planTagMessage.running',
    defaultMessage: 'Running'
  },
  senior: {
    id: 'planTagMessage.senior',
    defaultMessage: 'Senior'
  }
})

export const PLAN_TAG_TO_MESSAGE = {
  [PLAN_TAG.ALL]: planTagMessage.all,
  [PLAN_TAG.WOMEN]: planTagMessage.women,
  [PLAN_TAG.MEN]: planTagMessage.men,
  [PLAN_TAG.SUMMER]: planTagMessage.summer,
  [PLAN_TAG.CALISTHENICS]: planTagMessage.calisthenics,
  [PLAN_TAG.FAT_LOSS]: planTagMessage.fatLoss,
  [PLAN_TAG.POWERHYBRID]: planTagMessage.powerhybrid,
  [PLAN_TAG.BEGINNER]: planTagMessage.beginner,
  [PLAN_TAG.INTERMEDIATE]: planTagMessage.intermediate,
  [PLAN_TAG.ADVANCED]: planTagMessage.advanced,
  [PLAN_TAG.HIIT]: planTagMessage.hiit,
  [PLAN_TAG.HOME]: planTagMessage.home,
  [PLAN_TAG.DUMBBELL]: planTagMessage.dumbbell,
  [PLAN_TAG.FULL_BODY]: planTagMessage.fullBody,
  [PLAN_TAG.KETTLEBELL]: planTagMessage.kettlebell,
  [PLAN_TAG.RESISTANCE_BAND]: planTagMessage.resistanceBand,
  [PLAN_TAG.RUNNING]: planTagMessage.running,
  [PLAN_TAG.SENIOR]: planTagMessage.senior
}

const planTagTitleMessage = defineMessages({
  all: {
    id: 'planTagTitleMessage.all',
    defaultMessage: 'Workout Plans for Every Fitness Level and Goal'
  },
  women: {
    id: 'planTagTitleMessage.women',
    defaultMessage: 'Workout Plans for Women'
  },
  men: {
    id: 'planTagTitleMessage.men',
    defaultMessage: 'Workout Plans for Men'
  },
  summer: {
    id: 'planTagTitleMessage.summer',
    defaultMessage: 'Summer Workout Plans to Get Fit and Ready for the Season'
  },
  calisthenics: {
    id: 'planTagTitleMessage.calisthenics',
    defaultMessage: 'Calisthenics Workout Plans for Strength and Flexibility'
  },
  fatLoss: {
    id: 'planTagTitleMessage.fatLoss',
    defaultMessage: 'Fat Loss Workout Plans to Burn Calories and Shed Pounds'
  },
  powerhybrid: {
    id: 'planTagTitleMessage.powerhybrid',
    defaultMessage: 'Power and Hybrid Workout Plans for Strength and Stamina'
  },
  beginner: {
    id: 'planTagTitleMessage.beginner',
    defaultMessage: 'Beginner Workout Plans for Building Fitness Foundations'
  },
  intermediate: {
    id: 'planTagTitleMessage.intermediate',
    defaultMessage: 'Intermediate Workout Plans for Progressing Your Fitness'
  },
  advanced: {
    id: 'planTagTitleMessage.advanced',
    defaultMessage: 'Advanced Workout Plans for Challenging Your Limits'
  },
  hiit: {
    id: 'planTagTitleMessage.hiit',
    defaultMessage: 'HIIT Workout Plans for High-Intensity Fat Loss'
  },
  home: {
    id: 'planTagTitleMessage.home',
    defaultMessage: 'Home Workout Plans with Minimal Equipment Required'
  },
  dumbbell: {
    id: 'planTagTitleMessage.dumbbell',
    defaultMessage: 'Dumbbell Workout Plans for Strength and Conditioning'
  },
  fullBody: {
    id: 'planTagTitleMessage.fullBody',
    defaultMessage: 'Full Body Workout Plans for Overall Strength and Fitness'
  },
  kettlebell: {
    id: 'planTagTitleMessage.kettlebell',
    defaultMessage: 'Kettlebell Workout Plans for Strength and Endurance'
  },
  resistanceBand: {
    id: 'planTagTitleMessage.resistanceBand',
    defaultMessage: 'Resistance Band Workout Plans for Strength and Flexibility'
  },
  running: {
    id: 'planTagTitleMessage.running',
    defaultMessage: 'Running Workout Plans to Improve Speed and Stamina'
  },
  senior: {
    id: 'planTagTitleMessage.senior',
    defaultMessage: 'Senior Workout Plans Focused on Safe and Effective Workouts'
  }
})

export const PLAN_TAG_TO_TITLE_MESSAGE = {
  [PLAN_TAG.ALL]: planTagTitleMessage.all,
  [PLAN_TAG.WOMEN]: planTagTitleMessage.women,
  [PLAN_TAG.MEN]: planTagTitleMessage.men,
  [PLAN_TAG.SUMMER]: planTagTitleMessage.summer,
  [PLAN_TAG.CALISTHENICS]: planTagTitleMessage.calisthenics,
  [PLAN_TAG.FAT_LOSS]: planTagTitleMessage.fatLoss,
  [PLAN_TAG.POWERHYBRID]: planTagTitleMessage.powerhybrid,
  [PLAN_TAG.BEGINNER]: planTagTitleMessage.beginner,
  [PLAN_TAG.INTERMEDIATE]: planTagTitleMessage.intermediate,
  [PLAN_TAG.ADVANCED]: planTagTitleMessage.advanced,
  [PLAN_TAG.HIIT]: planTagTitleMessage.hiit,
  [PLAN_TAG.HOME]: planTagTitleMessage.home,
  [PLAN_TAG.DUMBBELL]: planTagTitleMessage.dumbbell,
  [PLAN_TAG.FULL_BODY]: planTagTitleMessage.fullBody,
  [PLAN_TAG.KETTLEBELL]: planTagTitleMessage.kettlebell,
  [PLAN_TAG.RESISTANCE_BAND]: planTagTitleMessage.resistanceBand,
  [PLAN_TAG.RUNNING]: planTagTitleMessage.running,
  [PLAN_TAG.SENIOR]: planTagTitleMessage.senior
}

const planTagToShortDescriptionMessage = defineMessages({
  all: {
    id: 'planTagToShortDescriptionMessage.all',
    defaultMessage: 'Browse all available workout routines'
  },
  women: {
    id: 'planTagToShortDescriptionMessage.women',
    defaultMessage: 'Workout routines specifically designed for women'
  },
  men: {
    id: 'planTagToShortDescriptionMessage.men',
    defaultMessage: 'Workout routines specifically designed for men'
  },
  summer: {
    id: 'planTagToShortDescriptionMessage.summer',
    defaultMessage: 'Get fit with summer-themed workout routines and routines'
  },
  calisthenics: {
    id: 'planTagToShortDescriptionMessage.calisthenics',
    defaultMessage: 'Master bodyweight exercises with calisthenics routines'
  },
  fatLoss: {
    id: 'planTagToShortDescriptionMessage.fatLoss',
    defaultMessage: 'Effective workout routines focused on fat loss and fitness'
  },
  powerhybrid: {
    id: 'planTagToShortDescriptionMessage.powerhybrid',
    defaultMessage: 'Powerhybrid routines combining strength and endurance training'
  },
  beginner: {
    id: 'planTagToShortDescriptionMessage.beginner',
    defaultMessage: 'Start your fitness journey with beginner workout routines'
  },
  intermediate: {
    id: 'planTagToShortDescriptionMessage.intermediate',
    defaultMessage: 'Challenge yourself with intermediate workout routines'
  },
  advanced: {
    id: 'planTagToShortDescriptionMessage.advanced',
    defaultMessage: 'Push your limits with advanced workout plans and routines'
  },
  hiit: {
    id: 'planTagToShortDescriptionMessage.hiit',
    defaultMessage: 'High-Intensity Interval Training (HIIT) workout plans'
  },
  home: {
    id: 'planTagToShortDescriptionMessage.home',
    defaultMessage: 'Convenient workout plans you can do at home with minimal equipment'
  },
  dumbbell: {
    id: 'planTagToShortDescriptionMessage.dumbbell',
    defaultMessage: 'Get stronger with dumbbell-focused workout plans'
  },
  fullBody: {
    id: 'planTagToShortDescriptionMessage.fullBody',
    defaultMessage: 'Comprehensive full-body workout plans for overall fitness'
  },
  kettlebell: {
    id: 'planTagToShortDescriptionMessage.kettlebell',
    defaultMessage: 'Build strength and endurance with kettlebell workouts'
  },
  resistanceBand: {
    id: 'planTagToShortDescriptionMessage.resistanceBand',
    defaultMessage: 'Effective resistance band workouts for strength and flexibility'
  },
  running: {
    id: 'planTagToShortDescriptionMessage.running',
    defaultMessage: 'Improve your stamina with running-focused workout plans'
  },
  senior: {
    id: 'planTagToShortDescriptionMessage.senior',
    defaultMessage: 'Gentle and effective workout plans for seniors'
  }
})

export const PLAN_TAG_TO_SHORT_DESCRIPTION_MESSAGE = {
  [PLAN_TAG.ALL]: planTagToShortDescriptionMessage.all,
  [PLAN_TAG.WOMEN]: planTagToShortDescriptionMessage.women,
  [PLAN_TAG.MEN]: planTagToShortDescriptionMessage.men,
  [PLAN_TAG.SUMMER]: planTagToShortDescriptionMessage.summer,
  [PLAN_TAG.CALISTHENICS]: planTagToShortDescriptionMessage.calisthenics,
  [PLAN_TAG.FAT_LOSS]: planTagToShortDescriptionMessage.fatLoss,
  [PLAN_TAG.POWERHYBRID]: planTagToShortDescriptionMessage.powerhybrid,
  [PLAN_TAG.BEGINNER]: planTagToShortDescriptionMessage.beginner,
  [PLAN_TAG.INTERMEDIATE]: planTagToShortDescriptionMessage.intermediate,
  [PLAN_TAG.ADVANCED]: planTagToShortDescriptionMessage.advanced,
  [PLAN_TAG.HIIT]: planTagToShortDescriptionMessage.hiit,
  [PLAN_TAG.HOME]: planTagToShortDescriptionMessage.home,
  [PLAN_TAG.DUMBBELL]: planTagToShortDescriptionMessage.dumbbell,
  [PLAN_TAG.FULL_BODY]: planTagToShortDescriptionMessage.fullBody,
  [PLAN_TAG.KETTLEBELL]: planTagToShortDescriptionMessage.kettlebell,
  [PLAN_TAG.RESISTANCE_BAND]: planTagToShortDescriptionMessage.resistanceBand,
  [PLAN_TAG.RUNNING]: planTagToShortDescriptionMessage.running,
  [PLAN_TAG.SENIOR]: planTagToShortDescriptionMessage.senior
}

const planTagToDescriptionMessage = defineMessages({
  all: {
    id: 'planTagToDescriptionMessage.all',
    defaultMessage: 'Browse all available workout plans and programs, offering a wide variety of routines to suit different fitness goals, levels, and preferences.'
  },
  women: {
    id: 'planTagToDescriptionMessage.women',
    defaultMessage: 'Explore workout programs specifically designed for women, featuring tailored exercises that cater to female fitness needs, from strength training to cardio.'
  },
  men: {
    id: 'planTagToDescriptionMessage.men',
    defaultMessage: 'Discover workout programs tailored for men, offering a range of workout routines that focus on building muscle, increasing strength, and improving overall fitness.'
  },
  summer: {
    id: 'planTagToDescriptionMessage.summer',
    defaultMessage: 'Get fit with summer-themed workout programs that help you achieve a lean physique, focusing on high-intensity routines perfect for the warmer months.'
  },
  calisthenics: {
    id: 'planTagToDescriptionMessage.calisthenics',
    defaultMessage: 'Master bodyweight exercises with calisthenics programs designed to build strength, flexibility, and endurance without the need for gym equipment.'
  },
  fatLoss: {
    id: 'planTagToDescriptionMessage.fatLoss',
    defaultMessage: 'Effective workout programs focused on fat loss, combining cardio and strength training exercises to help you shed pounds and improve your overall health.'
  },
  powerhybrid: {
    id: 'planTagToDescriptionMessage.powerhybrid',
    defaultMessage: 'Powerhybrid programs that combine strength and endurance training, offering a balanced approach to fitness that builds muscle while boosting cardiovascular health.'
  },
  beginner: {
    id: 'planTagToDescriptionMessage.beginner',
    defaultMessage: 'Start your fitness journey with beginner workout programs that provide simple yet effective routines designed to build a strong foundation for future progress.'
  },
  intermediate: {
    id: 'planTagToDescriptionMessage.intermediate',
    defaultMessage: 'Challenge yourself with intermediate workout programs that push your limits, helping you progress beyond the basics and achieve greater fitness milestones.'
  },
  advanced: {
    id: 'planTagToDescriptionMessage.advanced',
    defaultMessage: 'Push your limits with advanced workout programs designed for experienced fitness enthusiasts, featuring intense routines that maximize strength and endurance.'
  },
  hiit: {
    id: 'planTagToDescriptionMessage.hiit',
    defaultMessage: 'High-Intensity Interval Training (HIIT) workout programs that combine short bursts of intense exercise with recovery periods, maximizing calorie burn and fitness gains.'
  },
  home: {
    id: 'planTagToDescriptionMessage.home',
    defaultMessage: 'Convenient workout programs you can do at home with minimal equipment, designed to help you stay fit and active even without access to a gym.'
  },
  dumbbell: {
    id: 'planTagToDescriptionMessage.dumbbell',
    defaultMessage: 'Strengthen your body with dumbbell-focused workout programs, offering versatile routines that target various muscle groups for a full-body workout.'
  },
  fullBody: {
    id: 'planTagToDescriptionMessage.fullBody',
    defaultMessage: 'Comprehensive full-body workout programs that target all major muscle groups, providing balanced routines that improve overall fitness and physical conditioning.'
  },
  kettlebell: {
    id: 'planTagToDescriptionMessage.kettlebell',
    defaultMessage: 'Build strength, endurance, and coordination with kettlebell programs, featuring dynamic exercises that challenge your entire body and improve functional fitness.'
  },
  resistanceBand: {
    id: 'planTagToDescriptionMessage.resistanceBand',
    defaultMessage: 'Effective resistance band workout programs that enhance strength, flexibility, and muscle strength, offering a portable and versatile training option for all fitness levels.'
  },
  running: {
    id: 'planTagToDescriptionMessage.running',
    defaultMessage: 'Improve your stamina and cardiovascular health with running-focused workout programs, designed to help you increase speed, endurance, and overall running performance.'
  },
  senior: {
    id: 'planTagToDescriptionMessage.senior',
    defaultMessage: 'Gentle and effective workout programs for seniors, focusing on maintaining mobility, strength, and balance through low-impact exercises tailored to older adults.'
  }
})

export const PLAN_TAG_TO_DESCRIPTION_MESSAGE = {
  [PLAN_TAG.ALL]: planTagToDescriptionMessage.all,
  [PLAN_TAG.WOMEN]: planTagToDescriptionMessage.women,
  [PLAN_TAG.MEN]: planTagToDescriptionMessage.men,
  [PLAN_TAG.SUMMER]: planTagToDescriptionMessage.summer,
  [PLAN_TAG.CALISTHENICS]: planTagToDescriptionMessage.calisthenics,
  [PLAN_TAG.FAT_LOSS]: planTagToDescriptionMessage.fatLoss,
  [PLAN_TAG.POWERHYBRID]: planTagToDescriptionMessage.powerhybrid,
  [PLAN_TAG.BEGINNER]: planTagToDescriptionMessage.beginner,
  [PLAN_TAG.INTERMEDIATE]: planTagToDescriptionMessage.intermediate,
  [PLAN_TAG.ADVANCED]: planTagToDescriptionMessage.advanced,
  [PLAN_TAG.HIIT]: planTagToDescriptionMessage.hiit,
  [PLAN_TAG.HOME]: planTagToDescriptionMessage.home,
  [PLAN_TAG.DUMBBELL]: planTagToDescriptionMessage.dumbbell,
  [PLAN_TAG.FULL_BODY]: planTagToDescriptionMessage.fullBody,
  [PLAN_TAG.KETTLEBELL]: planTagToDescriptionMessage.kettlebell,
  [PLAN_TAG.RESISTANCE_BAND]: planTagToDescriptionMessage.resistanceBand,
  [PLAN_TAG.RUNNING]: planTagToDescriptionMessage.running,
  [PLAN_TAG.SENIOR]: planTagToDescriptionMessage.senior
}

export const PLAN_TAG_TO_SEARCH_TERM = {
  [PLAN_TAG.WOMEN]: [
    'women',
    'lower',
    'booty',
    'glute',
    'leg'
  ],
  [PLAN_TAG.MEN]: [
    'men',
    'for men',
    'upper'
  ],
  [PLAN_TAG.SUMMER]: [
    'summer',
    'lean',
    'fat',
    'conditioning'
  ],
  [PLAN_TAG.CALISTHENICS]: [
    'calisthenics',
    'bodyweight'
  ],
  [PLAN_TAG.FAT_LOSS]: [
    'loss',
    'cut',
    'burner',
    'hiit'
  ],
  [PLAN_TAG.POWERHYBRID]: [
    'powerhybrid'
  ],
  [PLAN_TAG.BEGINNER]: [
    'beginner',
    'foundation',
    'start'
  ],
  [PLAN_TAG.INTERMEDIATE]: [
    'intermediate'
  ],
  [PLAN_TAG.ADVANCED]: [
    'advanced'
  ],
  [PLAN_TAG.HIIT]: [
    'hiit'
  ],
  [PLAN_TAG.HOME]: [
    'home',
    'no equipment'
  ],
  [PLAN_TAG.DUMBBELL]: [
    'dumbbell',
    'db'
  ],
  [PLAN_TAG.FULL_BODY]: [
    'full body'
  ],
  [PLAN_TAG.KETTLEBELL]: [
    'kettlebell',
    'kb'
  ],
  [PLAN_TAG.RESISTANCE_BAND]: ['band'],
  [PLAN_TAG.RUNNING]: [
    'couch',
    'run',
    'hybrid'
  ],
  [PLAN_TAG.SENIOR]: ['senior']
}

export const PLAN_TAG_TO_SEARCH_TERM_TO_AVOID = {
  [PLAN_TAG.WOMEN]: PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR,
  [PLAN_TAG.MEN]: PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR
}

export const PLANS_DEFAULT_TAG_FILTER = 'all'
